import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { SwitchGroupMixin } from '../../mixins/components/SwitchGroupMixin';
import { SWITCH_SIZES } from '../../constants/SWITCH';
export var StyledSwitchGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledSwitchGroup",
  componentId: "c11n-8-64-0__sc-qe3ibz-0"
})(["", ""], SwitchGroupMixin);

var getChildProps = function getChildProps(_ref) {
  var size = _ref.size,
      fluid = _ref.fluid,
      labelPosition = _ref.labelPosition;
  var props = {
    fluid: fluid,
    labelPosition: labelPosition
  };

  if (typeof size !== 'undefined') {
    props.size = size;
  }

  return props;
};
/**
 * A collection of labeled [`Switch`](#/Form%20components?id=switch) components.
 *
 * @since 6.7.0
 */


var SwitchGroup = function SwitchGroup(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(StyledSwitchGroup, props, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, getChildProps(props));
  }));
};

SwitchGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Labeled `Switch` elements in the group */
  children: PropTypes.node.isRequired,

  /**
   * Set `size` for all child `Switch` components.
   * If defined, this will override any `size` value set on the individual components.
   */
  size: PropTypes.oneOf(Object.keys(SWITCH_SIZES)),

  /** `SwitchGroup` sets `LabeledControl` to be `fluid` by default */
  fluid: PropTypes.bool,

  /** `SwitchGroup` sets `LabeledControl` to have `left` positioned labels by default */
  labelPosition: PropTypes.oneOf(['left', 'right'])
} : {};
SwitchGroup.defaultProps = {
  size: undefined,
  fluid: true,
  labelPosition: 'left'
};
export default SwitchGroup;